"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.DEFAULT_PADDING = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var react_1 = require("@emotion/react");

exports.DEFAULT_PADDING = "20px";
var Root = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tmargin-right: auto;\n\tmargin-left: auto;\n\tbox-sizing: border-box;\n\t*,\n\t::after,\n\t::before {\n\t\tbox-sizing: inherit;\n\t}\n\n\t", "\n"])), function (props) {
  var theme = props.theme,
      width = props.width;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tmax-width: ", ";\n\t\t"])), width === "wide" ? theme.breakpoints.xxl : theme.breakpoints.xl);
});

var Container = function Container(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$vPadding = _ref.vPadding,
      vPadding = _ref$vPadding === void 0 ? exports.DEFAULT_PADDING : _ref$vPadding,
      _ref$hPadding = _ref.hPadding,
      hPadding = _ref$hPadding === void 0 ? exports.DEFAULT_PADDING : _ref$hPadding,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "standard" : _ref$width;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  return (0, jsx_runtime_1.jsx)(Root, {
    className: className,
    theme: theme,
    width: width,
    style: {
      paddingTop: "".concat(vPadding),
      paddingRight: "max(".concat(hPadding, ", env(safe-area-inset-right))"),
      paddingBottom: "".concat(vPadding),
      paddingLeft: "max(".concat(hPadding, ", env(safe-area-inset-left))")
    },
    children: children
  });
};

exports.Container = Container;